import React from "react";
import { LoanOffer } from "../types";
import { COLORS } from "../constants";

interface LoanOffersViewProps {
  offers?: LoanOffer[];
}

type DisplayableLoanOfferKeys = Exclude<
  keyof LoanOffer,
  "Installments_list"
>;

const LOAN_OFFER_COLUMNS: {
  header: string;
  key: DisplayableLoanOfferKeys;
}[] = [
  { header: "Loan Product", key: "loan_product" },
  { header: "Tenure", key: "tenure" },
  { header: "Principle", key: "principle" },
  { header: "Principle Max", key: "Principal_max" },
  { header: "Loan Amount", key: "loan_amount" },
  { header: "Interest", key: "interest" },
  { header: "Interest Rate", key: "interest_rate" },
  { header: "APR", key: "APR" },
  { header: "Package ID", key: "packageID" },
];


const LoanOffersView: React.FC<LoanOffersViewProps> = ({ offers = [] }) => {
  if (!offers.length) return null;

  return (
    <div className="table-responsive" style={{ marginTop: 10 }}>
      <table
        className="table text-center table-border spaced-table"
        style={{ minWidth: "100%" }}
      >
        {/* HEADER */}
        <thead style={{ background: COLORS.BG_LIGHTER }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {LOAN_OFFER_COLUMNS.map((col, index) => (
              <th key={`${col.header}-${index}`}>{col.header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {offers.map((row, rowIndex) => (
            <tr key={row.packageID ?? rowIndex}>
              {LOAN_OFFER_COLUMNS.map((col, colIndex) => {
                const value = row[col.key];

                let displayValue: React.ReactNode = "-";

                if (value !== null && value !== undefined) {
                  if (typeof value === "number") {
                    displayValue = value.toLocaleString(); // optional formatting
                  } else if (typeof value === "boolean") {
                    displayValue = value ? "Yes" : "No";
                  } else {
                    displayValue = value;
                  }
                }

                return (
                  <td key={`${col.header}-${colIndex}`}>{displayValue}</td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LoanOffersView;
